export default targetParent => ({
  name: 'detachable',

  data() {
    return {
      hasDetached: false,
    };
  },

  mounted() {
    this.initDetach();
  },

  beforeDestroy() {
    if (!this.$refs.content) {
      return;
    }

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) { console.log(e); }
  },

  methods: {
    initDetach() {
      if (this.hasDetached || !this.$refs.content) {
        return;
      }
      const target = document.querySelector(targetParent);
      if (!target) {
        return;
      }
      target.insertBefore(
        this.$refs.content,
        target.firstChild,
      );

      this.hasDetached = true;
    },
  },
});



// WEBPACK FOOTER //
// ./src/mixins/detachable.js